import React from 'react'
import LandingPage from '@/commons/containers/LandingPage'
	
const Home = () => <LandingPage/>

export default Home
